import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import ModalDialog from "@/components/ui/ModalDialog.vue";
import {provide, shallowRef} from "vue";
import router from "@/router";
import layouts from "@/layouts/layouts";
import ModalQr from "@/components/ui/ModalQr.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const layout = shallowRef("div");

router.afterEach((to: any) => {
  layout.value = (layouts as any)[to.meta.layout] || 'div';
});

provide("app:layout", layout);


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(layout.value || 'div'), null, {
      default: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    })),
    _createVNode(ModalDialog),
    _createVNode(ModalQr)
  ], 64))
}
}

})